import create from "zustand";
import { EdgeUserType, LoginData, LoginDataValidationErrors, ValidatableLoginData } from "../types";

export interface ILoginStore {
  loginHasFailed: boolean;
  isSubmitButtonLoading: boolean;
  loginData: LoginData;
  validationErrors: LoginDataValidationErrors;

  setLoginHasFailed: (loginHasFailed: boolean) => void;
  setSubmitButtonLoading: (isSubmitButtonLoading: boolean) => void;
  updateLoginData: (data: Partial<LoginData>) => void;
  updateValidationErrors: () => void;
  setValidationErrors: (errors: Partial<LoginDataValidationErrors>) => void;
}

const initialLoginData: LoginData = {
  returnUrl: '',
  userType: EdgeUserType.None,
  email: '',
};

const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmailValid = (email: string) => email && !!email.match(validEmailRegex);

export const getValidationErrors = (loginData: ValidatableLoginData): LoginDataValidationErrors => {
  const isBargeLogin = loginData.userType === EdgeUserType.Barge;
  const isCustomerLogin = loginData.userType === EdgeUserType.Customer;
  const isSurveyorLogin = loginData.userType === EdgeUserType.Surveyor;

  const email = !isEmailValid(loginData.email);
  const userType = !(isBargeLogin || isCustomerLogin || isSurveyorLogin);
  
  const displayName = !isBargeLogin && !loginData.displayName;
  const vesselName = !isBargeLogin && !loginData.vesselName;

  const licenseNumber = isSurveyorLogin && !loginData.licenseNumber;
  const rank = isCustomerLogin && !loginData.rank;

  const otp = !isBargeLogin && loginData.otp?.length !== 6;
  const password = isBargeLogin && !loginData.password;

  const userInfo = email || displayName || vesselName || licenseNumber || rank;
  const any = userInfo || otp || password;

  return {
    email,
    userType,
    displayName,
    vesselName,
    licenseNumber,
    rank,
    otp,
    password,
    userInfo,
    any
  };
};

export const useLoginStore = create<ILoginStore>((setState, getState) => ({
  loginHasFailed: false,
  isSubmitButtonLoading: false,
  loginData: initialLoginData,
  validationErrors: {
    any: false,
    userInfo: false,
  },

  setLoginHasFailed: (loginHasFailed: boolean) => setState({ loginHasFailed }),
  setSubmitButtonLoading: (isSubmitButtonLoading: boolean) => setState({ isSubmitButtonLoading }),

  updateLoginData: (partialData: Partial<LoginData>) => {
    const {
      loginData,
      validationErrors,
      loginHasFailed
    } = getState();

    const newLoginData = { ...loginData, ...partialData };
    const newValidationErrors = loginHasFailed ? getValidationErrors(newLoginData) : validationErrors;

    setState({ loginData: newLoginData, validationErrors: newValidationErrors });
  },

  updateValidationErrors: () => {
    const newValidationErrors = getValidationErrors(getState().loginData);
    setState({ validationErrors: newValidationErrors });
  },

  setValidationErrors: (errors: Partial<LoginDataValidationErrors>) => {
    const newValidationErrors = {
      ...getState().validationErrors,
      ...errors
    };
    setState({ validationErrors: newValidationErrors });
  },
}));